export default {
  data() {
    return {
      width: 820,
      height: 470,
      hostingUrl: "https://vkvideo.ru",
    }
  },
  methods: {
    // (url: string): string
    videoLink(url) {
      try {
        const match = url.match(/video-(\d+)_(\d+)/)
        if (!match) return null

        const [_, oid, id] = match

        return `${this.hostingUrl}/video_ext.php?oid=-${oid}&id=${id}&hd=1`
      } catch (e) {
        console.error(e)
        return ""
      }
    },
  },
}



// WEBPACK FOOTER //
// ./src/templates/components/ui-components/video-block/component.js